import * as React from 'react';
import { css } from 'emotion';
import { urlWineclub } from '../../../env';
import { mobilePx } from '../../_themes/deviceWidth';

const header = css`
  position: fixed;
  width: 100%;
  top: 0;
  height: 0;
  left: 0;
  z-index: 1999;
`;

const imageContainer = css`
  width: 100px;
  height: 100px;
  margin-top: calc(100px - 100px/2);
  margin-left: auto;
  margin-right: auto;
  @media screen and (max-width: ${mobilePx}) {
      width: 68px;
      height: 68px;
      margin-top: calc(100px - 68px/2);
    }
  }
`;

const circle = css`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

const mariPic = `${urlWineclub}/mari.jpg`;

const imageChoices = {
  mari: {
    src: mariPic,
    alt: 'mari',
    imgClass: circle,
  },
};

const HeaderOverlay = (imageChoice = 'mari') => {
  const choice = imageChoices[imageChoice] || {};
  const { src, alt, imgClass } = choice;
  return (
    <div className={header}>
      <div className={imageContainer}>
        <img className={imgClass} alt={alt} src={src} />
      </div>
    </div>
  );
};

export default HeaderOverlay;
